import { render, staticRenderFns } from "./CubeCanvas.vue?vue&type=template&id=c8c4c2be"
import script from "./CubeCanvas.vue?vue&type=script&lang=js"
export * from "./CubeCanvas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.9.1_vue-template-compiler@2.7.16_webpack@5.89.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports